import React from "react"

import LoadingPlaceholder from "./LoadingPlaceholder"
import TextSmallField from "./text/TextSmallField"
import TextBigField from "./text/TextBigField"
import Selector from "./selectors/Selector"
import TimeField from "./time/TimeField"
import NumberField from "./number/NumberField"
import CheckboxField from "./checkbox/CheckboxField"
import DateField from "./date/DateField"
import ToggleButtonField from "./toggle/ToggleButtonField"
import TagPicker from "./tagPicker/TagPicker"
import RichTextField from "./richText/RichTextField"
import InlineAttachment from "./attachments/InlineAttachment"
import MapField from "./map/MapField"
import LocationField from "./location/LocationField"
import Section from "./section/Section"
import InlineButtonsField from "./inlineButtons/InlineButtonsField"
import ItemPicker from "./itemPicker"
import {
    ICheckboxField,
    IDateField,
    IField,
    IInlineAttachmentField,
    IInlineButtonsField,
    IItemPickerField,
    ILocationField,
    IMapField,
    INumberField,
    IRichTextField,
    ISectionField,
    ISelectorField,
    ITagPickerField,
    ITextField,
    ITimeField,
    IToggleButtonField,
} from "../index"

interface FieldProp {
    field?: IField
    isLoading: boolean
}

export const Field = ({ field, isLoading }: FieldProp): JSX.Element => {
    if (!field) {
        return <>{isLoading && <LoadingPlaceholder />}</>
    }
    switch (field.type) {
        case "smallText":
        case "longText":
            return <TextSmallField field={field as ITextField} />
        case "bigText":
            return <TextBigField field={field as ITextField} />
        case "selector": {
            return <Selector {...(field as ISelectorField)} />
        }
        case "itemPicker":
            return <ItemPicker {...(field as IItemPickerField)} />
        case "tagPicker":
            return <TagPicker {...(field as ITagPickerField)} />
        case "time":
            return <TimeField field={field as ITimeField} />
        case "number":
            return <NumberField field={field as INumberField} />
        case "checkbox":
            return <CheckboxField field={field as ICheckboxField} />
        case "date":
            return <DateField field={field as IDateField} />
        case "toggle":
            return <ToggleButtonField field={field as IToggleButtonField} />
        case "richText":
            return <RichTextField field={field as IRichTextField} />
        case "map":
            return <MapField field={field as IMapField} />
        case "location":
            return <LocationField field={field as ILocationField} />
        case "section":
            return <Section field={field as ISectionField} />
        case "inlineAttachment":
            return <InlineAttachment field={field as IInlineAttachmentField} />
        case "inlineButtons":
            return <InlineButtonsField field={field as IInlineButtonsField} />

        default:
            return <></>
    }
}
